import styled from 'styled-components';

import PersonaEditor from './PersonaEditor';
import { PersonalizationFrame } from '../settings/PersonalizationFrame';

/**
 * Personalization as a main-pane destination. The heading keeps its natural
 * height and the editor takes the rest, so the file — not the page — scrolls.
 */
export default function PersonalizationView() {
  return (
    <Page>
      <PersonalizationFrame>
        <PersonaEditor />
      </PersonalizationFrame>
    </Page>
  );
}

const Page = styled.div`
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  padding: 20px 24px 24px;
  max-width: 920px;
  width: 100%;
  margin: 0 auto;
`;
